import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Alignment, Button } from 'tacho-ui';
interface ErrorComponentProps {
    error: string;
    resetErrorBoundary: () => void;
}

export function ErrorComponent(props: ErrorComponentProps) {
    const { formatMessage } = useIntl();

    return (
        <div className="majorLayoutMargin">
            <span className="text-danger">
                <FormattedMessage id="commonApplicationError" />
            </span>
            <pre>{props.error}</pre>
            <Button
                align={Alignment.center}
                text={formatMessage({ id: 'commonApplicationErrorRefresh' })}
                className="primary"
                onClick={props.resetErrorBoundary}
            />
        </div>
    );
}
